export const ModalType = {
  Delete: "delete",
  Edit: "edit",
};
